<template>
  <el-dialog
    :title="$t('text.dashboard_landing_slide6_title')"
    width="1300px"
    :visible="dialogVisible"
    :append-to-body="true"
    @close="handleClose"
    class="show-more-section"
  >
    <div class="pod-diaper popover-content">
      <div class="mb-10">{{ $t('text.setup_area_filter_desc') }}</div>
      <img
        class="wp-100"
        :src="
          require('@/assets/image/useful-features/dashboard-landing/dashboard-landing-area-filter.gif')
        "
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    handleClose() {
      // After close show more popup, then start the autoplay of the carousel
      this.$emit('changeAutoPlay', true)
      this.dialogVisible = false
    }
  }
}
</script>
